/* eslint-disable react/prop-types */
import React from 'react'
import { useSvg } from 'irmlib/hooks'

/**
 * @function
 * @description ChevronDown
 * @param {object} props props.
 * @param {string} props.fill Fill color for the icon. By default, it picks up the color of the nearest parent.
 * @param {number} props.scale Scale for the size of the icon. The default is 1.
 * @returns {object} svg of the icon
 */
export default props => {
  const viewBoxWidth = 12.727
  const viewBoxHeight = 7.277
  const [fill, width, height] = useSvg(props, viewBoxWidth, viewBoxHeight)
  return (
    <svg width={width} height={height} viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`} version='1.1' xmlns='http://www.w3.org/2000/svg'>
      <path id='Icon_ionic-ios-arrow-down' data-name='Icon ionic-ios-arrow-down' d='M12.553,16.33l4.812-4.816a.906.906,0,0,1,1.285,0,.917.917,0,0,1,0,1.288L13.2,18.259a.908.908,0,0,1-1.254.027L6.453,12.806a.91.91,0,1,1,1.285-1.288Z' transform='translate(-6.188 -11.246)' fill={fill} />
    </svg>
  )
}
